import { render, staticRenderFns } from "./DashboardGateway.vue?vue&type=template&id=8000dc78&"
import script from "./DashboardGateway.vue?vue&type=script&lang=js&"
export * from "./DashboardGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports